export const SMALL_HEIGHT_DISPLAY = '938px';
export const MAX_MOBILE_WIDTH = '767px';
export const MAX_TABLET_WIDTH = '992px';
export const MIN_TABLET_DESKTOP_WIDTH = '768px';
export const SPLITTER = ';,;';
export const TYPE = 'type';
export const BASE_SINGLE_SELECT_PROPS = {
  styles: {
    container: () => ({}),
    control: () => ({}),
    valueContainer: () => ({}),
    singleValue: () => ({}),
    dropdownIndicator: () => ({}),
    option: () => ({}),
    menu: () => ({}),
    menuList: () => ({})
  },
  components: {
    IndicatorSeparator: null
  },
  isSearchable: false,
  classNamePrefix: 'select-dropdown'
};